/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * For online bookings: how the meeting room is sourced.
 */
export enum ProfessionalBookingBaseResponseMeetingProvider {
  toptoptime = 'toptoptime',
  byo = 'byo'
}
